import Loader from '../../components/Loader';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import useClientUsers from './useClientUsers';

import AppHeader from '../../components/AppHeader';
import NoData from '../../components/NoData';
import useGetGeneralAppData from '../../hooks/useGetGeneralAppData';
import DeleteModal from './components/DeleteModal';
import ListHeader from './components/header';
import List from './components/list';
import SearchAtPage from './components/searchAtPage';

export default function ClientUsers() {
  const {
    filteredClientUsers,
    clientUsers,
    isLoading,
    apiFetched,
    handleTryAgain,
    clientUserBeingRemoved,
    deleteClientUser,
    handleChangeSearchTerm,
    searchTerm,
    deleteModalShow,
    handleOpenDeleteModal,
    setDeleteModalShow,
    downloadExcel,
  } = useClientUsers();

  const { companyCode } = useGetGeneralAppData();
  const isCompanySelected = !!companyCode;
  const hasClientlUsers = clientUsers?.length !== 0 && !!clientUsers && !isLoading;
  const filteredListLength = filteredClientUsers?.length ?? 0;
  const anyResultsByFilterSelection = filteredClientUsers.length === 0 && !isLoading && apiFetched;
  const isListEmpty = apiFetched && (!isLoading && clientUsers.length === 0);

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="ClientUsers" />
      <Transitions>
        <Loader isLoading={isLoading} />

        {isCompanySelected && (
          <>
            {hasClientlUsers && (
              <SearchAtPage
                searchTerm={searchTerm}
                onChangeSearchTerm={handleChangeSearchTerm}
              />
            )}

            <ListHeader
              doesListExists={hasClientlUsers}
              hasError={!apiFetched}
              filteredListLength={filteredListLength}
              singularLabel="usuário"
              pluralLabel="usuários"
              downloadExcel={downloadExcel}
            />

            {hasClientlUsers && (
              <List
                filteredList={filteredClientUsers}
                onOpenDeleteModal={handleOpenDeleteModal}
              />
            )}

            {anyResultsByFilterSelection && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                Não encontramos nenhum resultado.
                Por favor, tente alterar o campo de pesquisa.
                  </>
                )}
              />
            )}

            {!apiFetched && !isLoading && (
              <NoData
                icon="sad"
                label={(
                  <>
                Ocorreu um erro ao obter a lista dos usuários internos.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                .
                  </>
                )}
              />
            )}

            {isListEmpty && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                Não há nenhum usuário interno cadastrado, clique no botão
                    {' '}
                    <strong>Novo Usuário</strong>
                    {' '}
                acima para cadastrar seu primeiro!
                  </>
                )}
              />
            )}

            <DeleteModal
              clientUserBeingRemoved={clientUserBeingRemoved}
              setDeleteModalShow={setDeleteModalShow}
              deleteClientUser={deleteClientUser}
              deleteModalShow={deleteModalShow}
            />
          </>
        )}

        {!isCompanySelected && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
                Selecione uma empresa para visualizar os usuários.
              </>
            )}
          />
        )}

      </Transitions>
    </>
  );
}
